import { TIPO_DRE_PAGAMENTO } from "./tipoDrePagamento";

// TipoDrePag é compartilhado com a Omie, mas o significado destas três opções
// é exclusivo do Conta Azul V2.
export const CONTA_AZUL_TIPO_DRE_PAGAMENTO_OPTIONS = [
  { value: TIPO_DRE_PAGAMENTO.TITULOS_POR_DATA_PAGAMENTO, label: "Padrão atual usado por integrações Conta Azul" },
  { value: TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_RECEBIDO, label: "Valor pago ou recebido" },
  { value: TIPO_DRE_PAGAMENTO.BAIXAS_POR_VALOR_DA_CONTA, label: "Valor com ajustes separados" },
];

const DESCRICOES = {
  1: "Utiliza o cálculo atual das integrações conta azul, sem alterar os resultados já apresentados.",
  2: "Considera o valor líquido efetivamente movimentado em cada baixa, igual ao Fluxo de Caixa por pagamento, sem destacar ajustes financeiros ou perdas em linhas separadas.",
  3: "Considera o valor efetivamente pago ou recebido e mostra descontos, juros, multas e tarifas separadamente.",
};

export function getContaAzulTipoDrePagamentoDescricao(value) {
  return DESCRICOES[Number(value)] ?? DESCRICOES[1];
}
